import { useEffect } from 'react';

export const useMount = (callback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};
